import { Container } from "@mui/system";
import { useAuth } from "../context/AuthProvider";
import { useMenu } from "../context/MenuProvider";
import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { StyledPaper } from "../component/shared/StyledComponents";
import StrukturosPasirinkimai from "../component/BandosStruktura/StrukturosPasirinkimai";
import { useEffect, useMemo, useRef, useState } from "react";
import GrupiuSelectItem from "../component/shared/GrupiuSelectItem";
import { LaktacijuAmziai } from "../constants/ParametruGrupes";
import { FlexColumnBox } from "../component/shared/GrupiuSelectuList";
import Slankjuoste from "../component/kitimoIstorija/Slankjuoste";
import {
  LaktacijosTrukmeDienomis,
  LaktacijosTrukmeDienomisMazesne,
  MenesiaiAtgal,
  MenesiaiAtgalMazesnis,
} from "../constants/SlankjuostesZingniai";
import DvigubaSlankjuoste from "../component/BandosProduktyvumas/DvigubaSlankjuoste";
import { postItem } from "../Api/Api";
import { useNavigate } from "react-router-dom";
import { urlSuParametrais } from "../functions/urlSuParametrais";
import DvigubasGrafikas from "../component/BandosProduktyvumas/DvigubasGrafikas";
import DaugStulpeliuGrafikas from "../component/BandosProduktyvumas/DaugStulpeliuGrafikas";
import { laktacijuProduktyvumoMappinimas } from "../functions/laktacijuProduktyvumoMappinimas";
import DaugLinijuGrafikas from "../component/BandosProduktyvumas/DaugLinijuGrafikas";
import { calculateAbsoluteMinMax, grafikoDuomenys } from "../functions/produktyvumas/grafikuReziai";
import KarvesProduktyvumui from "../component/BandosProduktyvumas/KarvesProduktyvumui";
import { kontrolesPeriodai } from "../constants/KontrolesPeriodai";
import KarviuProduktyvumoLentele from "../component/BandosProduktyvumas/KarviuProduktyvumoLentele";
import { karviuProduktyvumasStulpeliaiMultiHeader } from "../constants/LenteliuStulpeliai";
import axios from "axios";
import { filterLaktacijosZymes } from "../functions/laktacijosZymes";
import useBreakpoints from "../styles/windowSizes";

const BandosProduktyvumas = () => {
  // [x]: prideti ant grafiku etiketes, kai mazas screen reiktu ant bars rodyti tik 5 laktacijos duomenis, nes taip pavaizduota Excel faile.
  // [x]: lenteliu reziai blogi, riekia kad nepersidengtu grafikai.
  const auth = useAuth();
  const menu = useMenu();
  const savininkas = menu.savininkas;
  const arSavininkas = auth.user.role === "Ūkis";

  const [duomenys, setDuomenys] = useState([]);
  const [karviuDuomenys, setKarviuDuomenys] = useState([]);
  const navigate = useNavigate();
  const [klaida, setKlaida] = useState("");

  const [bandos, setBandos] = useState(0);
  const [veisles, setVeisles] = useState(0);
  const [laktacijosReziai, setLaktacijosReziai] = useState([0, 1000]);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingKarviuDuomenys, setIsLoadingKarviuDuomenys] = useState(true);
  const [karves, setKarves] = useState([]);
  const [menesiaiAtgal, setMenesiaiAtgal] = useState(12);
  const [originalusKarviuSkaicius, setOriginalusKarviuSkaicius] = useState([0]);
  const cancelSourceRef = useRef();

  const [laktacijos, setLaktacijos] = useState(LaktacijuAmziai.map((g) => g.id));

  const laktacijosZymes = useMemo(() => {
    return filterLaktacijosZymes(laktacijos);
  }, [laktacijos]);

  const prevKarvesLengthRef = useRef(karves.length);
  const [karvesChangeTrigger, setKarvesChangeTrigger] = useState(0);

  const { isSm, isMd, isLg, isXl } = useBreakpoints();

  useEffect(() => {
    setBandos(0);
    setVeisles(0);
    setKarves([]);
    setLaktacijos(LaktacijuAmziai.map((g) => g.id));
    setOriginalusKarviuSkaicius(0);
    setDuomenys([]);
    setKarviuDuomenys([]);
    setLaktacijosReziai(() => [0, 1000]);
  }, [arSavininkas, savininkas]);

  useEffect(() => {
    const currentLength = karves.length;
    const prevLength = prevKarvesLengthRef.current;
    const maxLength = originalusKarviuSkaicius;

    // Check for the specific transitions you want to trigger on:
    // 1. From 1 to 0
    // 2. From max-1 to max
    // 3. Any values from 1 to max (excluding max to 0 and 0 to max)
    if (
      (prevLength === 1 && currentLength === 0) || // 1 to 0
      (prevLength === maxLength - 1 && currentLength === maxLength) || // max-1 to max
      (currentLength >= 1 &&
        currentLength <= maxLength &&
        !(prevLength === maxLength && currentLength === 0) &&
        !(prevLength === 0 && currentLength === maxLength))
      // Any value in range (but not max to 0, and not 0 to max)
    ) {
      // trigeris
      setKarvesChangeTrigger((prev) => prev + 1);
    }

    // Update the ref for next comparison
    prevKarvesLengthRef.current = currentLength;
  }, [karves.length, originalusKarviuSkaicius]);

  useEffect(() => {
    if (!(savininkas !== "" || arSavininkas)) return;

    if (cancelSourceRef.current) {
      cancelSourceRef.current.cancel("Canceled due to new request");
    }

    cancelSourceRef.current = axios.CancelToken.source();

    const params = [
      { parameter: arSavininkas, condition: "false", append: "savininkas", value: menu.savininkas },
      { parameter: bandos, condition: "!==0", append: "banda", value: bandos },
      { parameter: veisles, condition: "!==0", append: "veisle", value: veisles },
      {
        parameter: laktacijosReziai,
        condition: "more than 0",
        append: "trukme_nuo",
        value: laktacijosReziai[0],
      },
      {
        parameter: laktacijosReziai,
        condition: "less than 1000",
        append: "trukme_iki",
        value: laktacijosReziai[1],
      },
    ];
    let requestBody = {
      amziusLaktacijoms:
        laktacijosZymes.length > 0 && laktacijosZymes.length < 5 ? laktacijosZymes : [],
      karves: karves.length > 0 && karves.length < originalusKarviuSkaicius ? karves : [],
    };

    const timeout = setTimeout(() => {
      setIsLoading(true);
      setIsLoadingKarviuDuomenys(true);

      postItem(
        urlSuParametrais("produktyvumas", params),
        requestBody,
        cancelSourceRef.current.token
      )
        .then((data) => {
          data.data && setDuomenys(data.data);
          setKlaida("");
          setIsLoading(false);
        })
        .catch((err) => {
          if (axios.isCancel(err)) return;

          if (err.response) {
            const status = err.response.status;
            const errorMessage = err.response.data?.Error || err.response.data?.message;
            if (status === 404) {
              setKlaida(errorMessage);
              setDuomenys([]);
            }
            if (status === 401) navigate("/login");
          } else {
            setKlaida("Nepavyko gauti duomenų");
          }
        })
        .finally(() => setIsLoading(false));

      postItem(
        urlSuParametrais("produktyvumas/karves", params),
        requestBody,
        cancelSourceRef.current.token
      )
        .then((data) => {
          data.data && setKarviuDuomenys(data.data);
          setKlaida("");
        })
        .catch((err) => {
          if (axios.isCancel(err)) return;

          if (err.response) {
            const status = err.response?.status;
            const errorMessage = err.response?.data?.Error || err.response?.data?.message;
            console.log(err.response.data);

            if (status === 404) {
              setKarviuDuomenys([]); // Clear old data
              setKlaida(errorMessage);
            }
            if (status === 401) navigate("/login");
          } else {
            setKlaida("Nepavyko gauti duomenų");
          }
        })
        .finally(() => setIsLoadingKarviuDuomenys(false));
    }, 500); // 0.5s debounce

    return () => {
      clearTimeout(timeout);
      if (cancelSourceRef.current) {
        cancelSourceRef.current.cancel("Canceled due to new request");
      }
    };
  }, [
    menu.savininkas,
    savininkas,
    arSavininkas,
    bandos,
    veisles,
    laktacijosZymes,
    karvesChangeTrigger,
    laktacijosReziai,
  ]);

  const handleChangeKarve = (checked, value) => {
    if (checked) {
      if (value !== undefined) {
        setKarves([...karves, value]);
      }
    } else {
      if (value !== undefined) {
        setKarves(karves.filter((k) => k !== value));
      }
    }
  };

  const handleChangeKarvesVisos = (arr) => {
    setKarves(arr);
  };

  const duomenysPagalMenesiusAtgal =
    duomenys &&
    duomenys.filter((item) => {
      return kontrolesPeriodai.slice(0, menesiaiAtgal + 1).includes(item.menesis);
    });

  const karviuDuomenysMenesiusAtgal =
    karviuDuomenys &&
    karviuDuomenys.filter((item) => {
      return kontrolesPeriodai.slice(0, menesiaiAtgal + 1).includes(item.menesis);
    });

  const pienoDalys =
    duomenysPagalMenesiusAtgal &&
    duomenysPagalMenesiusAtgal.map(({ pienasDabar, pienasBuves, menesis }) => ({
      "Vid. pieno per einamąją laktaciją": pienasDabar,
      "Vid. pieno per buvusias laktacijas": pienasBuves,
      Mėnesis: menesis,
    }));

  const riebBaltDalys =
    duomenysPagalMenesiusAtgal &&
    duomenysPagalMenesiusAtgal.map(({ riebBaltDabar, riebBaltBuves, menesis }) => ({
      "Vid. riebalų + baltymų per einamąją laktaciją": riebBaltDabar,
      "Vid. riebalų + baltymų per buvusias laktacijas": riebBaltBuves,
      Mėnesis: menesis,
    }));

  const transformedData =
    duomenysPagalMenesiusAtgal && laktacijuProduktyvumoMappinimas(duomenysPagalMenesiusAtgal);

  const {
    yAxisMin: vidBandosPienasYAxisMin,
    yAxisMax: vidBandosPienasYAxisMax,
    chartData: vidBandosPienasChartData,
    raktai: vidBandosPienasRaktai,
  } = grafikoDuomenys(pienoDalys, null, "Mėnesis");

  const {
    yAxisMin: vidBandosRiebBaltYAxisMin,
    yAxisMax: vidBandosRiebBaltYAxisMax,
    chartData: vidBandosRiebBaltChartData,
    raktai: vidBandosRiebBaltRaktai,
  } = grafikoDuomenys(riebBaltDalys, null, "Mėnesis");

  const {
    yAxisMin: riebBaltDabarYAxisMin,
    yAxisMax: riebBaltDabarYAxisMax,
    chartData: riebBaltDabarChartData,
    raktai: riebBaltDabarRaktai,
  } = grafikoDuomenys(transformedData, "riebBaltDabar", "Mėnesis");

  const {
    yAxisMin: riebBaltBuvesYAxisMin,
    yAxisMax: riebBaltBuvesYAxisMax,
    chartData: riebBaltBuvesChartData,
    raktai: riebBaltBuvesRaktai,
  } = grafikoDuomenys(transformedData, "riebBaltBuves", "Mėnesis");

  const {
    yAxisMin: pienasDabarYAxisMin,
    yAxisMax: pienasDabarYAxisMax,
    chartData: pienasDabarChartData,
    raktai: pienasDabarRaktai,
  } = grafikoDuomenys(transformedData, "pienasDabar", "Mėnesis", true);

  const {
    yAxisMin: pienasBuvesYAxisMin,
    yAxisMax: pienasBuvesYAxisMax,
    chartData: pienasBuvesChartData,
    raktai: pienasBuvesRaktai,
  } = grafikoDuomenys(transformedData, "pienasBuves", "Mėnesis", true);

  const minsAndMaxesLines = [
    { min: vidBandosPienasYAxisMin, max: vidBandosPienasYAxisMax },
    { min: pienasDabarYAxisMin, max: pienasDabarYAxisMax },
    { min: pienasBuvesYAxisMin, max: pienasBuvesYAxisMax },
  ];

  const minsAndMaxesBars = [
    { min: vidBandosRiebBaltYAxisMin, max: vidBandosRiebBaltYAxisMax },
    { min: riebBaltDabarYAxisMin, max: riebBaltDabarYAxisMax },
    { min: riebBaltBuvesYAxisMin, max: riebBaltBuvesYAxisMax },
  ];

  const { absoluteMin: absoluteMinLines, absoluteMax: absoluteMaxLines } =
    calculateAbsoluteMinMax(minsAndMaxesLines);

  const { absoluteMin: absoluteMinBars, absoluteMax: absoluteMaxBars } =
    calculateAbsoluteMinMax(minsAndMaxesBars);

  const prevLacDataIsHigherThanCurrentOne = vidBandosPienasChartData.every((item) => {
    return item["Vid. pieno per einamąją laktaciją"] < item["Vid. pieno per buvusias laktacijas"];
  });

  return (
    <Container maxWidth="100vw" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" sx={{ marginBottom: "20px" }}>
        Bandos Produktyvumas
      </Typography>
      <Grid key="main" container spacing={2}>
        <Grid key="pasirinkimai" container spacing={2} size={{ xs: 12, md: 12, lg: 12, xl: 12 }}>
          <Grid
            key="pasirinkimasBeKarviu"
            container
            spacing={2}
            size={{ xs: 12, md: 8, lg: 8, xl: 8 }}
          >
            <Grid key="dropDownPasirinkimaiPopierius" size={{ xs: 12, md: 12, lg: 12, xl: 12 }}>
              <StyledPaper
                row="true"
                sx={{
                  gap: "30px",
                  justifyContent: "center",
                  alignItems: "center",
                  margin: "auto",
                }}
              >
                <Grid
                  key="dropDownPasirinkimai"
                  container
                  spacing={2}
                  size={{ xs: 12, lg: 12, xl: 12 }}
                >
                  <Grid key="bandosPasirinkimas" size={{ xs: 12, md: 4, lg: 4, xl: 4 }}>
                    <StrukturosPasirinkimai
                      banda={bandos}
                      setBanda={setBandos}
                      visosBandos={false}
                    />
                  </Grid>
                  <Grid key="veislesPasirinkimas" size={{ xs: 12, md: 4, lg: 4, xl: 4 }}>
                    <StrukturosPasirinkimai veisle={veisles} setVeisle={setVeisles} />
                  </Grid>
                  <Grid key="laktacijosAmziausPasirinkimas" size={{ xs: 12, md: 4, lg: 4, xl: 4 }}>
                    <FlexColumnBox>
                      <GrupiuSelectItem
                        pavadinimas={"Amžius laktacijomis"}
                        grupes={LaktacijuAmziai}
                        pasirinktos={laktacijos}
                        changeGrupes={setLaktacijos}
                        fullWidth
                        tekstas="Pasirinkta"
                      />
                    </FlexColumnBox>
                  </Grid>
                </Grid>
              </StyledPaper>
            </Grid>
            <Grid
              key="slankjuosciuPasirinkimai"
              container
              spacing={2}
              size={{ xs: 12, md: 12, lg: 12, xl: 12 }}
            >
              <Grid key="dvigubaSlankjuoste" size={{ xs: 12, md: 12, lg: 12, xl: 12 }}>
                <StyledPaper>
                  <DvigubaSlankjuoste
                    min={0}
                    max={1000}
                    zingsnis={10}
                    label="Minimum distance"
                    numatytoji={laktacijosReziai}
                    marksBigScreen={LaktacijosTrukmeDienomis}
                    marksSmallScreen={LaktacijosTrukmeDienomisMazesne}
                    changeValue={setLaktacijosReziai}
                    pavadinimas={`Buvusių laktacijų trukmė dienomis, nuo – iki`}
                    disableSwap
                    minSkirtumas={31}
                  />
                </StyledPaper>
              </Grid>
              <Grid key="slankjuoste" size={{ xs: 12, md: 12, lg: 12, xl: 12 }}>
                <StyledPaper>
                  <Slankjuoste
                    min={1}
                    max={12}
                    label="month-change"
                    numatytoji={12}
                    marksBigScreen={MenesiaiAtgal}
                    marksSmallScreen={MenesiaiAtgalMazesnis}
                    zingsnis={1}
                    changeValue={setMenesiaiAtgal}
                    pavadinimas="Pasirinkite kelių mėnesių produktyvumą norite stebėti"
                  />
                </StyledPaper>
              </Grid>
            </Grid>
          </Grid>
          <Grid key="karviuPasirinkimas" size={{ xs: 12, md: 4, lg: 4, xl: 4 }}>
            <StyledPaper
              sx={{
                height: "100%",
                minHeight: "357px",
                maxHeight: "385px",
                overflow: "hidden",
                zIndex: 1000,
              }}
            >
              <KarvesProduktyvumui
                savId={savininkas}
                bandos={bandos === 0 ? [] : [bandos]}
                karves={karves}
                changeKarves={handleChangeKarve}
                handleZymVisasKarves={handleChangeKarvesVisos}
                papildomaInfo
                veisles={veisles === 0 ? [] : [veisles]}
                dynamicSize
                laktacijos={laktacijosZymes}
                stickyHeader
                setOriginalusKarviuSkaicius={setOriginalusKarviuSkaicius}
              />
            </StyledPaper>
          </Grid>
        </Grid>
        <Grid container spacing={2} key="grafikai" size={{ xs: 12, md: 12, lg: 12, xl: 12 }}>
          <Grid key="VidBandosProduktyvumas" size={{ xs: 12, md: 12, lg: 12, xl: 12 }}>
            <StyledPaper sx={{ height: "100%", maxHeight: "500px" }}>
              <DvigubasGrafikas
                pavadinimas="Vidutinis bandos produktyvumas kg"
                isLoading={isLoading}
                chartDataLine={vidBandosPienasChartData}
                yAxisMinLine={Number((absoluteMinLines * 0.4).toFixed(0))}
                yAxisMaxLine={absoluteMaxLines}
                raktaiLine={vidBandosPienasRaktai}
                chartDataBar={vidBandosRiebBaltChartData}
                yAxisMinBar={0}
                yAxisMaxBar={Number((absoluteMaxBars * 1.9).toFixed(0))}
                raktaiBar={vidBandosRiebBaltRaktai}
                barHeight={300}
                barSize={isXl ? 50 : isLg ? 30 : isMd ? 20 : isSm ? 15 : 10}
                xAsis="Mėnesis"
                asisKaireje="Riebalai + baltymai"
                asisDesineje="Pienas"
                etikete
                angle={45}
                fill="black"
                prevLacDataIsHigherThanCurrentOne={prevLacDataIsHigherThanCurrentOne}
              />
            </StyledPaper>
          </Grid>
          <Grid key="pienasEinamoji" size={{ xs: 12, md: 6, lg: 6, xl: 6 }}>
            <StyledPaper sx={{ height: "100%", maxHeight: "400px" }}>
              <DaugLinijuGrafikas
                pavadinimas="Vidutinis pieno kiekio kg per einamą laktaciją kitimas"
                isLoading={isLoading}
                chartData={pienasDabarChartData}
                yAxisMin={absoluteMinLines}
                yAxisMax={absoluteMaxLines}
                raktai={pienasDabarRaktai}
                xAsis={"Mėnesis"}
                neraDuomenenuTekstas="Šiuo metu nėra karvių, kurių einamoji laktacija vyksta daugiau nei 305 d."
              />
            </StyledPaper>
          </Grid>
          <Grid key="pienasBuvusios" size={{ xs: 12, md: 6, lg: 6, xl: 6 }}>
            <StyledPaper sx={{ height: "100%", maxHeight: "400px" }}>
              <DaugLinijuGrafikas
                pavadinimas="Pieno kiekio kg vid. per visas buvusias laktacijas kitimas"
                isLoading={isLoading}
                chartData={pienasBuvesChartData}
                yAxisMin={absoluteMinLines}
                yAxisMax={absoluteMaxLines}
                raktai={pienasBuvesRaktai}
                xAsis={"Mėnesis"}
                spalvosPagalLaktacijas
                neraDuomenenuTekstas="Šiuo metu nėra karvių, kurių einamoji laktacija vyksta daugiau nei 305 d."
              />
            </StyledPaper>
          </Grid>
          <Grid key="riebalaiIrBaltymaiEinamajai" size={{ xs: 12, md: 6, lg: 6, xl: 6 }}>
            <StyledPaper sx={{ height: "100%", maxHeight: "400px" }}>
              <DaugStulpeliuGrafikas
                pavadinimas="Vidutinis riebalų + baltymų kg per einamą laktaciją kitimas"
                isLoading={isLoading}
                chartData={riebBaltDabarChartData}
                yAxisMin={absoluteMinBars}
                yAxisMax={absoluteMaxBars}
                raktai={riebBaltDabarRaktai}
                xAsis={"Mėnesis"}
                stulpeliaiSuEtiketemis={["4-5 lak.", "5+ lak."]}
                neraDuomenenuTekstas="Šiuo metu nėra karvių, kurių einamoji laktacija vyksta daugiau nei 305 d."
              />
            </StyledPaper>
          </Grid>
          <Grid key="riebalaiIrBaltymaiBuvusi" size={{ xs: 12, md: 6, lg: 6, xl: 6 }}>
            <StyledPaper sx={{ height: "100%", maxHeight: "400px" }}>
              <DaugStulpeliuGrafikas
                pavadinimas="Vidutinis riebalų + baltymų kg per visas buvusias laktacijas kitimas"
                isLoading={isLoading}
                chartData={riebBaltBuvesChartData}
                yAxisMin={absoluteMinBars}
                yAxisMax={absoluteMaxBars}
                raktai={riebBaltBuvesRaktai}
                xAsis={"Mėnesis"}
                stulpeliaiSuEtiketemis={["4-5 lak.", "5+ lak."]}
                neraDuomenenuTekstas="Šiuo metu nėra karvių, kurių einamoji laktacija vyksta daugiau nei 305 d."
              />
            </StyledPaper>
          </Grid>
          <Grid key="karviuDuomenys" size={{ xs: 12, md: 12, lg: 12, xl: 12 }}>
            <StyledPaper sx={{ height: "100%" }}>
              <KarviuProduktyvumoLentele
                pavadinimas="Karvių produktyvumas per laktaciją"
                isLoading={isLoadingKarviuDuomenys}
                duomenys={karviuDuomenysMenesiusAtgal}
                stulpeliai={karviuProduktyvumasStulpeliaiMultiHeader}
                banda={bandos !== 0 ? bandos : null}
                laktacijos={laktacijosReziai}
                excelFileName={`Karvių produktyvumas`}
              />
            </StyledPaper>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default BandosProduktyvumas;
